import React from 'react'
import ReactDOM from 'react-dom'
import {BrowserRouter as Router, Route} from 'react-router-dom'

import '@myxplor/ui/build/main.css'
import '@myxplor/forms/build/main.css'
import '@myxplor/icons/build/main.css'
import './styles.css'

import AppLayout from './layout'
import ChangePassword from './change-password'
import PasswordReset from './password-reset'
import CompletePasswordReset from './complete-password-reset'
import Impersonate from './impersonate'

ReactDOM.render(
  <Router>
    <AppLayout>
      <Route
        path='/change-password'
        render={() => (
          <ChangePassword />
        )}
      />

      <Route
        path='/password-reset/:strategies?'
        render= {({match}) => (
          <PasswordReset
            strategies={match.params.strategies}
          />
        )}
      />

      <Route
        path='/complete-password-reset/:token?'
        render= {({match}) => (
          <CompletePasswordReset
            token={match.params.token}
          />
        )}
      />

      <Route
        path='/impersonate'
        render= {({match}) => (
          <Impersonate />
        )}
      />
    </AppLayout>
  </Router>
  , document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js